/**
 * Refresh waypoint instances for an element.
 * Waypoints don't work properly for hidden elements, so they need to be refreshed when elements become visible.
 *
 * @since ??
 *
 * @param {JQuery} $element Element with waypoint instances to refresh.
 */
export const refreshWaypointInstances = ($element: JQuery): void => {
  const waypointInstances = $element.data('et_waypoint');
  if (waypointInstances && Array.isArray(waypointInstances)) {
    waypointInstances.forEach(instance => {
      if (instance?.context?.refresh) {
        setTimeout(() => {
          instance.context.refresh();
        }, 0);
      }
    });
  }
};
